var map = {
	"./7News.jpg": 608,
	"./9News.jpg": 609,
	"./ABCNews.jpg": 610,
	"./BrisbaneTimes.jpg": 611,
	"./CanberraTimes.jpg": 612,
	"./SBSNews.jpg": 613,
	"./TheAge.jpg": 614,
	"./TheConversation.jpg": 615,
	"./TheGuardian.jpg": 616,
	"./TheSydneyMorningHerald.jpg": 617,
	"./TheWestAustralian.jpg": 618,
	"./WAToday.jpg": 619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 607;